module.exports = {"headerColumns":{"tariffName":"Product","discountDays":"Geldigheid","dateEffective":"Ingangsdatum","endDate":"Einddatum","entryStationName":"Beginstation","exitStationName":"Eindstation","rorRegions":"Regio(s)","price":"Bedrag"}}


//////////////////
// WEBPACK FOOTER
// ./src/locale/nl/ror-product.json
// module id = HmAF
// module chunks = 1